var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.81,
    height: 15.718,
    viewBox: "0 0 23.81 15.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1480",
    "data-name": "Rectangle 1480",
    width: 23.81,
    height: 15.718,
    transform: "translate(0 0)",
    fill: "#534ed9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M11.9,15.718C5.525,15.718.534,8.63.325,8.328L0,7.859.325,7.39C.534,7.088,5.525,0,11.9,0s11.37,7.088,11.579,7.39l.325.469-.325.469c-.209.3-5.2,7.39-11.579,7.39M2.028,7.859C3.216,9.38,7.26,14.074,11.9,14.074s8.687-4.694,9.876-6.215C20.592,6.338,16.549,1.645,11.9,1.645S3.216,6.338,2.028,7.859",
    fill: "#534ed9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M11.9,15.274a7.191,7.191,0,1,1,7.19-7.191,7.2,7.2,0,0,1-7.19,7.191m0-12.737a5.546,5.546,0,1,0,5.546,5.546A5.553,5.553,0,0,0,11.9,2.537",
    fill: "#534ed9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M13.385,8.263a1.659,1.659,0,0,1-.944-3.025,2.952,2.952,0,0,0-.536-.054,2.922,2.922,0,1,0,2.844,2.362,1.656,1.656,0,0,1-1.364.717",
    fill: "#534ed9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon_eye.58f34a292d4887400ebf3063c38c34f1.svg";
export { ForwardRef as ReactComponent };